import React, { PureComponent } from "react";

class Classic extends PureComponent {
    render() {
        return (
            <svg width="25" height="6" viewBox="0 0 25 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_165_1769)">
                    <path d="M22.4995 1.19922H2.51953C1.6911 1.19922 1.01953 2.0051 1.01953 2.99922C1.01953 3.99333 1.6911 4.79922 2.51953 4.79922H22.4995C23.328 4.79922 23.9995 3.99333 23.9995 2.99922C23.9995 2.0051 23.328 1.19922 22.4995 1.19922Z" stroke="#181818" strokeWidth="0.9" strokeMiterlimit="10" />
                </g>
                <defs>
                    <clipPath id="clip0_165_1769">
                        <rect width="25" height="6" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default Classic;